import styles from '../../../styles.module.scss';
import skeleton from './styles.module.scss';
import { GameLeaderboardTableRowSkeletonProps } from './props';

export default function GameLeaderboardTableRowSkeleton({
  shouldShowReducedInfo,
}: GameLeaderboardTableRowSkeletonProps) {
  return (
    <tr className={styles.table__row}>
      <td
        className={`${styles.table__row__data} ${styles['table__row__data--primary']}`}
      >
        <div className={skeleton.text} />
      </td>

      {!shouldShowReducedInfo ? (
        <>
          <td
            className={`${styles.table__row__data} ${styles['table__row__data--center']}`}
          >
            <div className={`${skeleton.text} ${skeleton['text--center']}`} />
          </td>

          <td
            className={`${styles.table__row__data} ${styles['table__row__data--center']}`}
          >
            <div className={`${skeleton.text} ${skeleton['text--center']}`} />
          </td>

          <td
            className={`${styles.table__row__data} ${styles['table__row__data--right']}`}
          >
            <div className={`${skeleton.text} ${skeleton['text--right']}`} />
          </td>
        </>
      ) : (
        <td
          className={`${styles.table__row__data} ${styles['table__row__data--right']}`}
        >
          <div className={`${skeleton.text} ${skeleton['text--right']}`} />
        </td>
      )}
    </tr>
  );
}
